<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter header-nano"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
          >
            <h4>
              {{ message.heading }}
            </h4>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised text-center textInCard">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="html-message" v-html="message.html"></div>
        </div>
      </div>
      <router-link :to='"/dorfladen/" + message.user.id'>
        <md-button class="md-success dorfladen-button">
          alle Nachrichten ansehen
        </md-button>
      </router-link>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  mixins: [Mixins.HeaderImage],
  bodyClass: "about-us",
  data() {
    return {
      image: require("@/assets/img/dorfladen/landscape-666927_1280.jpg"),
      message: null
    };
  },
  mounted() {
    this.loadData(this.$route.params.id);
  },
  computed: {
    ...mapGetters(["backendServer"])
  },
  methods: {
    loadData(massageId) {
      let vm = this;
      let getUrl = this.backendServer + "newsFeedEntry/" + massageId;
      axios
        .get(getUrl)
        .then(function(response) {
          vm.message = response.data;
        })
        .catch(function(e) {
          vm.$router.push({ path: '/' })
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.mt-2 {
  margin-top: 1.5rem;
}
.section {
  padding: 20px 0 !important;
}
.html-message {
  padding: 20px;
}
.dorfladen-button {
  margin-bottom: 20px;
}
.textInCard {
  overflow-wrap: break-word;
}
</style>
